/* global axios */
import ApiClient from '../ApiClient';

class PilotDocuments extends ApiClient {
  constructor() {
    super('pilot/documents', { accountScoped: true });
  }

  get({ page = 1, assistantId } = {}) {
    return axios.get(this.url, {
      params: { page, assistant_id: assistantId },
    });
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  // 筛选文档（用于知识库详情页）
  filter({ knowledgeBaseId, page, search, sort, payload }) {
    const params = { knowledge_base_id: knowledgeBaseId, page };
    if (search) params.search = search;
    if (sort) params.sort = sort;

    return axios.post(`${this.url}/filter`, { ...params, payload });
  }

  create(data = {}) {
    // 如果是FormData，直接发送；否则包装在document对象中
    if (data instanceof FormData) {
      return axios.post(this.url, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
    }
    return axios.post(this.url, {
      document: data,
    });
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  retry(id) {
    const url = `${this.url}/${id}/retry`;
    console.log('[PilotDocuments API] retry URL:', url);
    console.log('[PilotDocuments API] this.url:', this.url);
    return axios.post(url);
  }
}

export default new PilotDocuments();
